import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";

const ServiceMasterForm = (props) => {
  const currentDate = new Date().toISOString().substr(0, 10);
  const [moduleId, setModuleId] = useState();

  const [subServiceId, setSubServiceId] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [serviceCode, setServiceCode] = useState("");
  const [serviceUrl, setServiceUrl] = useState("");
  const [serviceImgUrl, setServiceImgUrl] = useState("");
  const [approvalRequired, setApprovalRequired] = useState(false);
  const [mobileService, setMobileService] = useState(false);

  const [close, setClose] = useState(false);

  const [subClose, setSubClose] = useState(false);

  const [moduleName, setModuleName] = useState("");
  const [moduleCode, setModuleCode] = useState("");
  const [moduleImgUrl, setModuleImgUrl] = useState("");
  const [superModule, setSuperModule] = useState(false);

  const [subModuleId, setSubModuleId] = useState("");
  const [subServiceName, setSubServiceName] = useState("");
  const [subUrl, setSubUrl] = useState("");

  const [moduleData, setModuleData] = useState([]);
  const [subServicesData, setSubServicesData] = useState([]);
  const [subServicesFilterList, setSubServicesFilterList] = useState([]);

  const [servicesData, setServicesData] = useState([]);

  const { sendRequest: postModuleMaster } = useHttp();

  const moduleMaster = (e) => {
    e.preventDefault();

    const isNameExists =
      moduleData &&
      moduleData.some((module) => module.moduleName === moduleName);
    const isCodeExists =
      moduleData &&
      moduleData.some((module) => module.moduleCode === moduleCode);

    if (isNameExists) {
      toast.error("Module Name already exists.");
      return;
    }

    if (isCodeExists) {
      toast.error("Module Code already exists.");
      return;
    }

    const data = [
      {
        createdDate: moment(currentDate).format("DD/MM/YYYY"),
        moduleName: moduleName,
        moduleCode: moduleCode,
        moduleImageUrl: moduleImgUrl,
        superModule: superModule,
        status: 1,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
      },
    ];

    // console.log(data);

    postModuleMaster(
      {
        url: "/api/moduleMaster/",

        method: "POST",

        body: data,
      },
      (data) => {
        if (data) {
          toast.success(`Module Added`);
          getAllModules();
          setModuleName("");
          setModuleImgUrl("");
          setSuperModule("");
          setModuleCode("");
          setClose(false);
        }
      }
    );
  };

  const { sendRequest: getModules } = useHttp();

  const getAllModules = () => {
    getModules(
      {
        url: "/api/moduleMaster/",
      },
      (res) => {
        if (res) {
          setModuleData(res);
        }
      }
    );
  };
  useEffect(() => {
    getAllModules();
  }, [getModules]);

  const { sendRequest: getSubServices } = useHttp();

  const allSubServices = () => {
    getSubServices(
      {
        url: "/api/serviceSubMaster/",
      },
      (res) => {
        if (res) {
          setSubServicesData(res);
          setSubServicesFilterList(res);
        }
      }
    );
  };
  useEffect(() => {
    allSubServices();
  }, [getSubServices]);

  const onModuleChange = (e) => {
    let Id = parseInt(e.target.value) || 0;
    // console.log(Id);

    setModuleId(Id);

    if (Id) {
      const subservicesFilterList =
        subServicesData &&
        subServicesData.filter(
          (item) => parseInt(item.moduleId) === parseInt(Id)
        );

      setSubServicesFilterList(subservicesFilterList);
    }
  };

  const { sendRequest: postSubServiceMaster } = useHttp();

  const subServicessubmitHandler = (e) => {
    e.preventDefault();

    const isNameExists =
      subServicesData &&
      subServicesData.some(
        (subSer) =>
          subSer.serviceSubName === subServiceName &&
          subSer.moduleId === subModuleId
      );

    if (isNameExists) {
      toast.error("Sub Service already exists.");
      return;
    }

    const data = [
      {
        serviceSubName: subServiceName,
        serviceSubImageUrl: subUrl,
        status: 1,
        createdDate: moment(currentDate).format("DD/MM/YYYY"),
        moduleId: subModuleId,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
      },
    ];

    //console.log(data);

    postSubServiceMaster(
      {
        url: "/api/serviceSubMaster/",

        method: "POST",
        body: data,
      },
      (data) => {
        if (data) {
          toast.success(`Sub Service Added`);
          allSubServices();
          setSubModuleId("");
          setSubServiceName("");
          setSubUrl("");

          setSubClose(false);
        }
      }
    );
  };

  const { sendRequest: getServices } = useHttp();
  useEffect(() => {
    getServices(
      {
        url: `/api/serviceMaster/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setServicesData(res);
        }
      }
    );
  }, [getServices]);

  const { sendRequest: PostService } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const isUpdate = props.update && props.update.serviceId;

    // normalize ids to numbers for reliable comparison
    const currentModuleId = Number(moduleId || 0);
    const currentSubServiceId = Number(subServiceId || 0);
    const updatingServiceId = isUpdate ? Number(props.update.serviceId) : null;

    // Validate service name uniqueness WITHIN same module + subservice
    const isNameExists =
      servicesData &&
      servicesData.some((service) => {
        const svcModuleId = Number(service.moduleId || 0);
        const svcSubId = Number(service.serviceSubId || 0);
        const svcId = service.serviceId ? Number(service.serviceId) : null;

        // match name + same module + same subservice
        const sameNameModuleSub =
          service.serviceName === serviceName &&
          svcModuleId === currentModuleId &&
          svcSubId === currentSubServiceId;

        // if updating, ignore the same record
        if (isUpdate) {
          return sameNameModuleSub && svcId !== updatingServiceId;
        }
        return sameNameModuleSub;
      });

    // Keep other validations (URL/Code) as before (they're global in your original logic)
    const isUrlExists =
      !isUpdate &&
      servicesData &&
      servicesData?.some((service) => service.serviceUrl === serviceUrl);

    const isCodeExists =
      !isUpdate &&
      servicesData &&
      servicesData?.some((service) => service.serviceCode === serviceCode);

    if (isNameExists) {
      toast.error(
        "Service Name already exists for the selected Module/Sub Service."
      );
      return;
    }

    if (isUrlExists) {
      toast.error("Service Url already exists.");
      return;
    }

    if (isCodeExists) {
      toast.error("Service Code already exists.");
      return;
    }
    const data = [
      {
        moduleId: moduleId,
        serviceSubId: parseInt(subServiceId),
        serviceName: serviceName,
        serviceCode: serviceCode,
        serviceImageUrl: serviceImgUrl,
        serviceUrl: serviceUrl,
        approvalRequired: approvalRequired,
        isMobileService: mobileService,
        status: 1,
        createdDate: moment(currentDate).format("DD/MM/YYYY"),

        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
      },
    ];

    console.log(data);
    if (props.update) {
      data[0].serviceId = props.update.serviceId;
    }
    PostService(
      {
        url: "/api/serviceMaster/",

        method: "POST",
        body: data,
      },
      (data) => {
        if (data) {
          toast.success(`Service ${props.update ? "Updated" : "Added"}`);
          setModuleId("");
          setSubServiceId("");
          setServiceName("");
          setServiceCode("");
          setServiceImgUrl("");
          setServiceUrl("");
          setApprovalRequired(false);
          setMobileService(false);
          props.addForm(false);
        }
      },
      (error) => {
        console.log(error);
        toast.error(error);
      }
    );
  };

  useEffect(() => {
    setModuleId(props.update.moduleId || "");

    const subservicesFilterList =
      subServicesData &&
      subServicesData.filter(
        (item) => parseInt(item.moduleId) === parseInt(props.update.moduleId)
      );

    setSubServicesFilterList(subservicesFilterList);

    if (props.update.moduleId) {
      console.log(props.update);

      setSubServiceId(props.update.serviceSubId || "");
      setServiceName(props.update.serviceName || "");
      setServiceCode(props.update.serviceCode || "");
      setServiceUrl(props.update.serviceUrl || "");
      setServiceImgUrl(props.update.serviceImageUrl || "");
    }
  }, [props.update]);

  return (
    <>
      <div className="modal fade" id="modal-sm">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <label className="modal-title">Add Module Master</label>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form style={{ margin: "10px" }} onSubmit={moduleMaster}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Module Name</label>
                  <input
                    type={"text"}
                    id={"moduleName"}
                    required
                    className="form-control"
                    value={moduleName}
                    onChange={(e) => {
                      setModuleName(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>Module Code</label>
                  <input
                    type={"text"}
                    id={"moduleCode"}
                    required
                    className="form-control"
                    value={moduleCode}
                    onChange={(e) => {
                      setModuleCode(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>Module Image Url</label>
                  <input
                    type={"text"}
                    id={"moduleCode"}
                    required
                    className="form-control"
                    value={moduleImgUrl}
                    onChange={(e) => {
                      setModuleImgUrl(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      id={"superModule"}
                      value={superModule}
                      onChange={(e) => {
                        setSuperModule(e.target.checked);
                      }}
                    />{" "}
                    Super Module
                  </label>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button className="btn btn-primary">Add</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modal-cropDetail" //ref={modalRef}
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <label className="modal-title">Add Sub Service Master</label>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={subServicessubmitHandler}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Module Name</label>
                  <select
                    id="subModuleId"
                    className="form-control"
                    value={subModuleId}
                    onChange={(e) => {
                      setSubModuleId(e.target.value);
                    }}
                    required
                  >
                    <option value="">Select Module</option>
                    {moduleData &&
                      moduleData.map((x) => (
                        <option key={x.moduleId} value={x.moduleId}>
                          {x.moduleName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Sub Service Name</label>
                  <input
                    type={"text"}
                    id={"subServiceName"}
                    required
                    className="form-control"
                    value={subServiceName}
                    onChange={(e) => {
                      setSubServiceName(e.target.value);
                    }}
                  />
                </div>

                <div className="form-group">
                  <label>Sub Service Image Url</label>
                  <input
                    type={"text"}
                    id={"subUrl"}
                    required
                    className="form-control"
                    value={subUrl}
                    onChange={(e) => {
                      setSubUrl(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button className="btn btn-primary">Add</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Service Master</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <div>
                          {" "}
                          <label>Module Name </label>
                          <button
                            type="button"
                            className="btn-primary"
                            data-toggle="modal"
                            data-target="#modal-sm"
                          >
                            +
                          </button>
                        </div>
                        <select
                          id="moduleId"
                          className="form-control"
                          value={moduleId}
                          onChange={(e) => {
                            onModuleChange(e);
                          }}
                          required
                        >
                          <option value="">Select Module</option>
                          {moduleData &&
                            moduleData.map((x) => (
                              <option key={x.moduleId} value={x.moduleId}>
                                {x.moduleName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Sub Service Name </label>
                        <button
                          type="button"
                          className="btn-primary"
                          data-toggle="modal"
                          data-target="#modal-cropDetail"
                        >
                          +
                        </button>

                        <select
                          id="subServiceId"
                          className="form-control"
                          value={subServiceId}
                          onChange={(e) => {
                            setSubServiceId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Sub Service</option>
                          {subServicesFilterList &&
                            subServicesFilterList.map((x) => (
                              <option
                                key={x.serviceSubId}
                                value={x.serviceSubId}
                              >
                                {x.serviceSubName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Service Name</label>

                        <input
                          type="text"
                          id="serviceName"
                          className="form-control"
                          autoComplete="off"
                          required
                          value={serviceName}
                          onChange={(e) => {
                            setServiceName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Service Code</label>
                        <input
                          type="text"
                          id="serviceCode"
                          className="form-control"
                          autoComplete="off"
                          required
                          value={serviceCode}
                          onChange={(e) => {
                            setServiceCode(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Service Url</label>
                        <input
                          type="text"
                          id="serviceUrl"
                          className="form-control"
                          autoComplete="off"
                          required
                          value={serviceUrl}
                          onChange={(e) => {
                            setServiceUrl(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Service Image Url</label>
                        <input
                          type="text"
                          id="serviceImgUrl"
                          className="form-control"
                          autoComplete="off"
                          required
                          value={serviceImgUrl}
                          onChange={(e) => {
                            setServiceImgUrl(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div class="checkbox">
                        <label>
                          <input
                            type="checkbox"
                            value={approvalRequired}
                            onChange={(e) => {
                              setApprovalRequired(e.target.checked);
                            }}
                          />{" "}
                          Approval Required
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="checkbox">
                        <label>
                          <input
                            type="checkbox"
                            value={mobileService}
                            onChange={(e) => {
                              setMobileService(e.target.checked);
                            }}
                          />{" "}
                          Is Mobile Service
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default ServiceMasterForm;
